import styled, { keyframes } from 'styled-components';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

const tutorialShimmer = keyframes`
	0% {
		background-position: 200% 0;
	}

	100% {
		background-position: -200% 0;
	}
`;

export const Container = styled.header`
  width: 100%;
  height: 56px;
  background: transparent;
  margin-bottom: -10px;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  gap: 16px;
`;

export const Title = styled.div`
  margin: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  text-overflow: ellipsis;
  color: #5e5e60;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
`;

export const SecondaryButton = styled.button`
  display: inline-flex;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #5e5e60;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &:focus-visible {
    outline: 2px solid #017556;
    outline-offset: 2px;
  }
`;

export const ButtonIconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;

  & .MuiSvgIcon-root {
    display: block;
    fill: #5e5e60;
  }
`;

export const HelpButtonIconSlot = styled(ButtonIconSlot)`
  transform: translateY(1px);
`;

export const TutorialModal = styled(Modal)`
  .MuiBackdrop-root {
    background: rgba(15, 23, 42, 0.84);
  }
`;

export const TutorialModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(100vw - 32px, 960px);
  padding: 20px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.24);
  outline: none;

  @media (max-width: 768px) {
    padding: 16px;
    width: min(100vw - 24px, 960px);
  }
`;

export const TutorialModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
`;

export const TutorialModalTitle = styled.h2`
  margin: 0;
  color: #5e5e60;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
`;

export const TutorialModalCloseButton = styled(IconButton)`
  flex-shrink: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.08) !important;
  }

  & .MuiSvgIcon-root {
    fill: #5e5e60;
  }
`;

export const TutorialIframeWrapper = styled.div<{ $isLoading: boolean }>`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background: #000000;
  aspect-ratio: 16 / 9;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      #5e5e60 0%,
      #3b3b3d 35%,
      #636366 50%,
      #3b3b3d 65%,
      #5e5e60 100%
    );
    background-size: 200% 100%;
    animation: ${tutorialShimmer} 2.5s linear infinite;
    opacity: ${({ $isLoading }) => ($isLoading ? 1 : 0)};
    transition: opacity 0.24s ease;
    pointer-events: none;
    z-index: 1;
  }
`;

export const TutorialIframe = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  position: relative;
  z-index: 0;
`;
